export const PIX_KEY_TYPE_VALUES = {
  CPF: 'cpf',
  CNPJ: 'cnpj',
  EMAIL: 'email',
  PHONE: 'phone',
  RANDOM: 'chave_aleatoria',
};

export const PIX_KEY_TYPE_LABELS = {
  [PIX_KEY_TYPE_VALUES.CPF]: 'CPF',
  [PIX_KEY_TYPE_VALUES.CNPJ]: 'CNPJ',
  [PIX_KEY_TYPE_VALUES.EMAIL]: 'E-mail',
  [PIX_KEY_TYPE_VALUES.PHONE]: 'Telefone',
  [PIX_KEY_TYPE_VALUES.RANDOM]: 'Chave Aleatória',
};

export const pixKeyTypes = [
  {
    label: PIX_KEY_TYPE_LABELS[PIX_KEY_TYPE_VALUES.CPF],
    value: PIX_KEY_TYPE_VALUES.CPF,
  },
  {
    label: PIX_KEY_TYPE_LABELS[PIX_KEY_TYPE_VALUES.CNPJ],
    value: PIX_KEY_TYPE_VALUES.CNPJ,
  },
  {
    label: PIX_KEY_TYPE_LABELS[PIX_KEY_TYPE_VALUES.EMAIL],
    value: PIX_KEY_TYPE_VALUES.EMAIL,
  },
  {
    label: PIX_KEY_TYPE_LABELS[PIX_KEY_TYPE_VALUES.PHONE],
    value: PIX_KEY_TYPE_VALUES.PHONE,
  },
  {
    label: PIX_KEY_TYPE_LABELS[PIX_KEY_TYPE_VALUES.RANDOM],
    value: PIX_KEY_TYPE_VALUES.RANDOM,
  },
];
